<mat-dialog-content>
  <div class="grid tk-grid-rows place-items-center  custom-font">
    <div class="mx-auto flex-1 flex-col place-items-center">

      <div class="mb-16 grid place-items-center">
        <div class="i-server-error"></div>
      </div>

      <div class="text-xl text-white font-semibold text-center mb-3 w-70">Serwer jest chwilowo przeciążony spróbuj
        ponownie za kilka minut
      </div>

      <div class="text-xs text-white text-center w-70">Pracujemy obecnie, aby przywrócić pełną sprawność aplikacji jak
        najszybciej.
        Spróbuj ponownie za kilka minut. Jeśli będzie nadal występować skontaktuj się z BOK tel. <a
          href="tel:{{'contact.phone-no-spaces'|translate}}"><span class="text-white">{{ 'contact.phone' | translate }}</span></a></div>

    </div>

    <button mat-flat-button color="primary" type="button"
            class=" flex justify-center items-center font-normal hover:font-normal"
            (click)="onSubmit()">
      <div class=" mx-6 text-sm text-white">Odśwież aplikację</div>
    </button>

  </div>
</mat-dialog-content>
